import React from 'react'
import TestNotTaken from '../Components/TestNotTaken/TestNotTaken'

const TestNotTakenView = () => {
  return (
    <div>
        <TestNotTaken />
    </div>
  )
}

export default TestNotTakenView